module.exports = __webpack_public_path__ + "img/md.75ec533a.svg";